<template>
	<div class="bg-white custom-shadow">
		<q-parallax :height="130">
			<template v-slot:media>
				<img :src="getBanner" />
			</template>

			<div class="custom-container">
				<q-breadcrumbs class="bc-text text-weight-bold">
					<template v-slot:separator>
						<q-icon size="1.2em" name="fal fa-chevron-right" color="white" />
					</template>

					<q-breadcrumbs-el icon="fal fa-home" :label="$t('home')" :to="{ name: 'home' }" />
				</q-breadcrumbs>

				<span class="text-h3 text-white">{{ $t(getPageName) }}</span>
			</div>
		</q-parallax>

		<div class="custom-container q-py-sm">
			<span v-for="(button, index) in navbar" :key="index">
				<q-btn
					flat
					size="lg"
					:color="button.to == $route.meta.title ? 'dark' : 'blue-grey-4'"
					:label="$t(button.text)"
					@click="$router.push({ name: button.to })"
					v-if="button.to"
					no-caps
				/>
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'NavbarContentDesktop',

	computed: {
		...mapGetters({
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getBanner() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})

			if (obj && obj.home_banner && obj.home_banner !== 'https://image.jpg') return obj.home_banner
			else return ''
		},

		navbar() {
			let navbar = []

			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					if (obj.has_courses) {
						navbar.push({
							to: 'courses',
							text: obj.title_trainings == '' ? 'online_courses' : obj.title_trainings,
						})
					}

					if (obj.has_live_classes) {
						navbar.push({
							to: 'live_classes',
							text: obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes,
						})
					}

					if (obj.has_presential) {
						navbar.push({
							to: 'presentials',
							text: obj.title_presential == '' ? 'presential_courses' : obj.title_presential,
						})
					}

					if (obj.has_trails) {
						navbar.push({
							to: 'trails',
							text: obj.title_trails == '' ? 'trails' : obj.title_trails,
						})
					}

					if (obj.has_webcasts) {
						navbar.push({
							to: 'webinars',
							text: obj.title_webcasts == '' ? 'webinars' : obj.title_webcasts,
						})
					}

					if (obj.has_podcasts) {
						navbar.push({
							to: 'podcasts',
							text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts,
						})
					}
				}
			}

			return navbar
		},

		getPageName() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})

				if (obj) {
					switch (this.$route.meta.title) {
						case 'courses':
							return obj.title_trainings == '' ? 'online_courses' : obj.title_trainings
							break
						case 'presentials':
							return obj.title_presential == '' ? 'presential_courses' : obj.title_presential
							break
						case 'trails':
							return obj.title_trails == '' ? 'trails' : obj.title_trails
							break
						case 'webinars':
							return obj.title_webcasts == '' ? 'webinars' : obj.title_webcasts
							break
						case 'live_classes':
							return obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes
							break
						case 'podcasts':
							return obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts
							break
					}
				}
			} else {
				return ''
			}
		},
	},
}
</script>

<style></style>
